import { render, staticRenderFns } from "./Especialidad.vue?vue&type=template&id=63e0bb00&"
import script from "./Especialidad.vue?vue&type=script&lang=js&"
export * from "./Especialidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QToolbar,QBreadcrumbs,QBreadcrumbsEl,QSpace,QBtn,QTable,QTd,QChip,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QToolbar,QBreadcrumbs,QBreadcrumbsEl,QSpace,QBtn,QTable,QTd,QChip,QIcon})
